import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import UserList from '../views/UserList.vue'
import ActivityList from '../views/ActivityList.vue'
import KnowledgeList from '../views/KnowledgeList.vue'
import ExpertCourses from '../views/ExpertCourses.vue'
import ExpertArticles from '../views/ExpertArticles.vue'
import KnowledgeShares from '../views/KnowledgeShares.vue'
import KnowledgeUpdates from '../views/KnowledgeUpdates.vue'
import TechDocuments from '../views/TechDocuments.vue'
import TradingList from '../views/TradingList.vue'
import IndustryList from '../views/IndustryList.vue'
import SuggestionsList from '../views/SuggestionsList.vue'
import InquiriesList from '../views/InquiriesList.vue'
import YaoxieList from '../views/YaoxieList.vue'
import DaodiHerbsList from '../views/DaodiHerbsList.vue'
import Pharmacopoeia2025List from '../views/Pharmacopoeia2025List.vue'
// Wave 7 新增14个页面
import Dashboard from '../views/Dashboard.vue'
import HerbsList from '../views/HerbsList.vue'
import HerbProductionsList from '../views/HerbProductionsList.vue'
import GapBasesList from '../views/GapBasesList.vue'
import CollectionSchemesList from '../views/CollectionSchemesList.vue'
import XianxianCompaniesList from '../views/XianxianCompaniesList.vue'
import XianxianHerbsList from '../views/XianxianHerbsList.vue'
import MarketPricesList from '../views/MarketPricesList.vue'
import OriginPricesList from '../views/OriginPricesList.vue'
import IndustryNewsList from '../views/IndustryNewsList.vue'
import QueryLogsList from '../views/QueryLogsList.vue'
import PaymentRecordsList from '../views/PaymentRecordsList.vue'
import FavoritesList from '../views/FavoritesList.vue'
import UploadedFilesList from '../views/UploadedFilesList.vue'
import KnowledgeSharesList from '../views/KnowledgeSharesList.vue'
import PolicyFilesList from '../views/PolicyFilesList.vue'
import CrawlLogs from '../views/CrawlLogs.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // Dashboard
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  // 政策法规
  {
    path: '/policy-files',
    name: 'PolicyFilesList',
    component: PolicyFilesList,
    meta: { requiresAuth: true }
  },
  // 用户管理
  {
    path: '/users',
    name: 'UserList',
    component: UserList,
    meta: { requiresAuth: true }
  },
  // 药材相关
{
    path: '/herbs',
    name: 'HerbsList',
    component: HerbsList,
    meta: { requiresAuth: true }
  },
  {
    path: '/herb-productions',
    name: 'HerbProductionsList',
    component: HerbProductionsList,
    meta: { requiresAuth: true }
  },
  {
    path: '/gap-bases',
    name: 'GapBasesList',
    component: GapBasesList,
    meta: { requiresAuth: true }
  },
{
    path: '/daodi-herbs',
    name: 'DaodiHerbsList',
    component: DaodiHerbsList,
    meta: { requiresAuth: true }
  },
  {
    path: '/pharmacopoeia-2025',
    name: 'Pharmacopoeia2025List',
    component: Pharmacopoeia2025List,
    meta: { requiresAuth: true }
  },
  {
    path: '/collection-schemes',
    name: 'CollectionSchemesList',
    component: CollectionSchemesList,
    meta: { requiresAuth: true }
  },
  // 越鲜相关
  {
    path: '/xianxian-companies',
    name: 'XianxianCompaniesList',
    component: XianxianCompaniesList,
    meta: { requiresAuth: true }
  },
  {
    path: '/xianxian-herbs',
    name: 'XianxianHerbsList',
    component: XianxianHerbsList,
    meta: { requiresAuth: true }
  },
  // 价格行情
  {
    path: '/market-prices',
    name: 'MarketPricesList',
    component: MarketPricesList,
    meta: { requiresAuth: true }
  },
  {
    path: '/origin-prices',
    name: 'OriginPricesList',
    component: OriginPricesList,
    meta: { requiresAuth: true }
  },
  // 采销信息
  {
    path: '/trading',
    name: 'TradingList',
    component: TradingList,
    meta: { requiresAuth: true }
  },
  // 产业链
  {
    path: '/industry',
    name: 'IndustryList',
    component: IndustryList,
    meta: { requiresAuth: true }
  },
  {
    path: '/industry-news',
    name: 'IndustryNewsList',
    component: IndustryNewsList,
    meta: { requiresAuth: true }
  },
  // 建议反馈
  {
    path: '/suggestions',
    name: 'SuggestionsList',
    component: SuggestionsList,
    meta: { requiresAuth: true }
  },
  // 问询记录
  {
    path: '/inquiries',
    name: 'InquiriesList',
    component: InquiriesList,
    meta: { requiresAuth: true }
  },
  // 食药同源
  {
    path: '/yaoxie',
    name: 'YaoxieList',
    component: YaoxieList,
    meta: { requiresAuth: true }
  },
  {
    path: '/daodi-herbs',
    name: 'DaodiHerbsList',
    component: DaodiHerbsList,
    meta: { requiresAuth: true }
  },
  // 活动管理
  {
    path: '/activities',
    name: 'ActivityList',
    component: ActivityList,
    meta: { requiresAuth: true }
  },
  // 记录管理
  {
    path: '/query-logs',
    name: 'QueryLogsList',
    component: QueryLogsList,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-records',
    name: 'PaymentRecordsList',
    component: PaymentRecordsList,
    meta: { requiresAuth: true }
  },
  {
    path: '/favorites',
    name: 'FavoritesList',
    component: FavoritesList,
    meta: { requiresAuth: true }
  },
  {
    path: '/uploaded-files',
    name: 'UploadedFilesList',
    component: UploadedFilesList,
    meta: { requiresAuth: true }
  },
  // 知识库
  {
    path: '/knowledge',
    name: 'KnowledgeList',
    component: KnowledgeList,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge/documents',
    name: 'TechDocuments',
    component: TechDocuments,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge/courses',
    name: 'ExpertCourses',
    component: ExpertCourses,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge/articles',
    name: 'ExpertArticles',
    component: ExpertArticles,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge/shares',
    name: 'KnowledgeShares',
    component: KnowledgeShares,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge/updates',
    name: 'KnowledgeUpdates',
    component: KnowledgeUpdates,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge/shares-list',
    name: 'KnowledgeSharesList',
    component: KnowledgeSharesList,
    meta: { requiresAuth: true }
  },
  {
    path: '/crawl-logs',
    name: 'CrawlLogs',
    component: CrawlLogs,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory('/admin/'),
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('adminLoggedIn') === 'true'
  const adminPassword = sessionStorage.getItem('adminPassword')

  if (to.meta.requiresAuth && (!isLoggedIn || !adminPassword)) {
    next('/login')
  } else {
    next()
  }
})

export default router